import React, { PureComponent, PropTypes } from 'react';
import Fuse from 'fuse.js';
import _every from 'lodash/every';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _sortBy from 'lodash/sortBy';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import _size from 'lodash/size';

import Heading from '../Heading';
import Item from './Item';
import AnyItem from './AnyItem';
import FilterItem from './FilterItem';
import TextAreaItem from './TextAreaItem';

import './SelectList.css';
import '../../../fixed-header-view.css';

const MAX_RESULTS = 39;

export default class SelectList extends PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        items: PropTypes.object,
        idPropName: PropTypes.string,
        valuePropName: PropTypes.string,
        isDeletedPropName: PropTypes.string,
        subValueFunc: PropTypes.func,
        allowAny: PropTypes.bool,
        customSortBy: PropTypes.func,
        selectedItemId: PropTypes.number,
        setSelectedItem: PropTypes.func.isRequired,
        freeTextValue: PropTypes.string,
        setFreeTextItem: PropTypes.func,
    }

    static defaultProps = {
        items: {},
        idPropName: `id`,
        valuePropName: `name`,
        isDeletedPropName: `isDeleted`,
        allowAny: false,
        hasFreeTextItem: false,
    }

    constructor(props) {
        super(props);

        this.state = {
            filter: null,
            items: this.normalizeItems(props),
        };

        this.filterChanged = this.filterChanged.bind(this);
    }

    componentWillMount() {
        this.autoSelectOnlyListItem(this.state.items, this.props.selectedItemId);
    }

    componentWillReceiveProps(nextProps) {
        const nextItems = this.normalizeItems(nextProps);

        this.setState({
            items: nextItems,
        });

        this.autoSelectOnlyListItem(nextItems, nextProps.selectedItemId);
    }

    normalizeItems(props) {
        const {
            idPropName,
            valuePropName,
            isDeletedPropName,
            subValueFunc,
        } = props;

        const nonDeletedItems = _filter(props.items, (item) => {
            return !item[isDeletedPropName];
        });

        return _map(nonDeletedItems, (item) => {
            const subtext = subValueFunc ? subValueFunc(item) : null;
            return {
                id: item[idPropName],
                text: item[valuePropName],
                subtext
            };
        });
    }

    autoSelectOnlyListItem(items, selectedItemId) {
        // If there is one item in the list and no custom entry auto select it
        if (!selectedItemId && items.length === 1 && !this.props.setFreeTextItem) {
            this.props.setSelectedItem(
                items[0].id,
                items[0].text
            );
        }
    }

    filterChanged(filter) {
        this.setState({ filter });
        this.props.setSelectedItem(null, null);
    }

    filterItems() {
        const { items } = this.state;

        let result = items;
        if (this.state.filter != null) {
            const fuse = new Fuse(items, {
                threshold: 0.4,
                keys: [`text`, `subtext`],
            });

            result = fuse.search(this.state.filter);
        } else {
            result = _sortBy(result, this.props.customSortBy || `text`);
        }

        return result;
    }

    getAnyItemJsx() {
        const {
            allowAny,
            selectedItemId,
            setSelectedItem,
         } = this.props;

        if (!allowAny)
            return null;

        const isSelected = selectedItemId === null;

        return (
            <AnyItem
                key="any"
                isSelected={isSelected}
                onClick={setSelectedItem}
            />
        );
    }

    getItemJsx(item) {
        const {
            idPropName,
            valuePropName,
            selectedItemId,
            setSelectedItem,
            subValueFunc,
        } = this.props;

        const {
            id,
            text,
            subtext
        } = item;
        const isSelected = id === selectedItemId;

        return (
            <Item
                key={id}
                id={id}
                text={text}
                subtext={subtext}
                isSelected={isSelected}
                onClick={setSelectedItem}
            ></Item>
        );
    }

    render() {
        const {
            idPropName,
            selectedItemId,
            freeTextValue,
            setFreeTextItem,
        } = this.props;
        const { items } = this.state;

        let filterItemJsx;
        let anyItemJsx;
        let itemsJsx;
        let selectedItemJsx;
        if (items.length > 0) {
            filterItemJsx = <FilterItem filterChanged={this.filterChanged} />;

            anyItemJsx = this.getAnyItemJsx();

            const filteredItems = this.filterItems();
            let filteredListContainsSelectedItem = false;
            itemsJsx = _map(filteredItems.slice(0, MAX_RESULTS), item => {
                if (item.id === selectedItemId)
                    filteredListContainsSelectedItem = true;

                return this.getItemJsx(item);
            });

            // Show the selected item at the top, unless it is in the filtered list.
            if (selectedItemId && !filteredListContainsSelectedItem) {
                selectedItemJsx = this.getItemJsx(_find(items, (item) => {
                    return item.id == selectedItemId;
                }));
            }
        }

        const freeTextItemJsx = this.props.setFreeTextItem ?
            <Item isSelected={freeTextValue !== null}>
                <TextAreaItem
                    value={freeTextValue}
                    setValue={setFreeTextItem}
                    />
            </Item> : null;

        return (
            <div className="fixed-header-view">
                <Heading title={this.props.title} />
                {filterItemJsx}
                <div className="select-list content">
                    <ul className="items">
                        {freeTextItemJsx}
                        {anyItemJsx}
                        {selectedItemJsx}
                        {itemsJsx}
                    </ul>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/SelectList/SelectList.jsx